import React, { useEffect, useRef, useState } from "react"
import { Overlay, Tooltip } from "react-bootstrap"
import PropTypes from "prop-types"

import "app/static/frontend/components/stylus/Tooltip.styl"
import "app/static/stylus/tooltip-i.styl"

export const Tip = ({ label, ...props }) => {
    const [show, setShow] = useState(false)
    const targetRef = useRef(null)
    const showTimer = useRef(null)
    const hideTimer = useRef(null)

    const clearTimers = () => {
        if (showTimer.current) {
            clearTimeout(showTimer.current)
            showTimer.current = null
        }
        if (hideTimer.current) {
            clearTimeout(hideTimer.current)
            hideTimer.current = null
        }
    }

    const handleEnter = () => {
        clearTimers()
        const delay = props.delayShow || 150
        showTimer.current = setTimeout(() => setShow(true), delay)
    }

    const handleLeave = () => {
        clearTimers()
        // Tiny delay to allow moving between trigger and tooltip without flicker
        hideTimer.current = setTimeout(() => setShow(false), 50)
    }

    useEffect(() => () => clearTimers(), [])

    const overlay = (overlayProps) => (
        <Tooltip
            id={label}
            className="tooltip-z-index"
            {...overlayProps}
            onMouseEnter={handleEnter}
            onMouseLeave={handleLeave}
        >
            {label}
        </Tooltip>
    )

    if (!label) return props.children

    return (
        <>
            <span ref={targetRef} onMouseEnter={handleEnter} onMouseLeave={handleLeave}>
                {props.children}
            </span>

            <Overlay
                target={targetRef.current}
                show={show}
                placement={props.placement || "bottom"}
                container={typeof document !== "undefined" ? document.body : undefined}
                popperConfig={{
                    strategy: "fixed",
                    modifiers: [
                        {
                            name: "preventOverflow",
                            options: {
                                mainAxis: true,
                                altAxis: true,
                                tether: false,
                                padding: 8,
                                boundary: "viewport",
                                rootBoundary: "viewport",
                            },
                        },
                        { name: "offset", options: { offset: [0, 8] } },
                        { name: "hide", enabled: false },
                        { name: "computeStyles", options: { adaptive: false, gpuAcceleration: false } },
                    ],
                }}
            >
                {overlay}
            </Overlay>
        </>
    )
}

Tip.propTypes = {
    label: PropTypes.string.isRequired,
    placement: PropTypes.string,
    delayShow: PropTypes.number,
    children: PropTypes.node,
    rootClose: PropTypes.bool,
}

Tip.defaultProps = {
    rootClose: true,
    placement: "bottom",
    delayShow: 150,
}

export default Tip
